import BuildResumeModal from './BuildResumeModal';

export default BuildResumeModal;
